import React, { useEffect, Fragment, useState } from 'react'
import axioInstance from '../axiosInstance';
import { useForm } from 'react-hook-form'

import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

export default function EditAssumptions({ toggleClass, setActive, roiOption, riskAssetMax }) {

    const Back = () => {
        setActive(false);
    }

    // eslint-disable-next-line
    const { register, handleSubmit, formState: { errors } } = useForm();

    const onSubmit = data => {


        const profile_id = sessionStorage.getItem('profile_id');


        const postData = { profile_id: profile_id, assumption: { equity: equityReturn, debt: debtReturn, gold: goldReturn, property: propertyReturn } };

        axioInstance.post(`profile-assumptions/update_assumption`, postData)
            .then(function (response) {


                if (roiOption === "1") {

                    axioInstance.post(`summary/calculate-roi`, { profile_id: profile_id, asset_alloc: riskAssetMax }).then(
                        (response, data) => {
                            const summaryUpdate = {
                                profile_id: profile_id,
                                roiChange: 1,
                                roi: response.data.roi * 100,
                                asset_alloc: (response.data.asset_alloc * 100)
                            }

                            axioInstance.post(`goals/reset`, { profile_id: profile_id })
                                .then(function (response) {


                                    axioInstance.post(`profile/summary-update`, summaryUpdate).then(
                                        (response, data) => {
                                            window.location.reload();
                                        }
                                    );


                                })

                        });

                } else {



                    const gpostData = { profile_id: profile_id };
                    axioInstance.post(`goals/reset`, gpostData)
                        .then(function (response) {

                            axioInstance.post(`profile/summary-update`, { profile_id: profile_id }).then(
                                (response, data) => {
                                    window.location.reload();
                                }
                            );


                        })


                }




            })

    }

    const [equityReturn, setEquityReturn] = useState();
    const [debtReturn, setDebtReturn] = useState();
    const [goldReturn, setGoldReturn] = useState();
    const [propertyReturn, setPropertyReturn] = useState();

    const equityPerc = (e) => {
        setEquityReturn(e);
    }

    const debtPerc = (e) => {
        setDebtReturn(e);
    }

    const goldPerc = (e) => {
        setGoldReturn(e);
    }

    const propertyPerc = (e) => {
        setPropertyReturn(e);
    }

    useEffect(() => {

        const profile_id = sessionStorage.getItem('profile_id');

        /*

        04-APRIL-2025 - Anoj Tambe - Removed summary api call and replaced with get_assumptions

        */
        axioInstance.post(`get_assumption_by_profile_id`, {profile_id:profile_id}).then(
            (response, data) => {


                setEquityReturn(parseInt(response.data.equity));
                setDebtReturn(parseInt(response.data.debt));
                setGoldReturn(parseInt(response.data.gold));
                setPropertyReturn(parseInt(response.data.property));


            });

    }, []);


    return (
        <Fragment>
            <div className="rightSide_menu_outer">
                <div className="rightSide_menu">

                    <div className="rightSide_menu_header">
                        <div>
                            <button type="button" className="btn btn-outline-primary btn-sm d-none d-md-block d-lg-block" onClick={() => Back()}>Back</button>
                        </div>
                        <div className="font14 fw500 color182">
                            Edit Assumption
                        </div>
                        <div>&nbsp;</div>
                    </div>
                    <div className="topBanner pl25">
                        <img src='/images/rupeee.png' alt='img' className='sidebarRupeeeIcon' />
                        <div className="font18 fw600 color182">Edit Assumption</div>
                        <div className="font14 fw500 color485">plan in your financial journey</div>
                    </div>

                    <div className="form_prnt p20">
                        <form className="custome_form" onSubmit={handleSubmit(onSubmit)}>

                            <div className="rangesliderbox">
                                <div className="rangesliderbox_title">
                                    <div>
                                        <div className="font12 fw500 color8c9">Equity Investments will grow at</div>
                                    </div>
                                    <div className="tragetvalue font13 fw700">{equityReturn}</div>
                                </div>
                                <div className="rangebox_bar mt12">
                                    <div className="form-group">


                                        <Slider step={1} min={5} max={20} onChange={e => equityPerc(e)} value={equityReturn} />

                                    </div>
                                </div>
                                <div className="flex_center justify_center mt8">
                                    <div className="font12 fw500 color9ba">5</div>
                                    <div className="font12 fw500 color9ba">20</div>
                                </div>
                                <input type="hidden" className="font14 fw500 ml15 mr15" name='equityReturn' value={equityReturn} {...register("equityReturn")} />
                            </div>


                            <div className="devider_line mt25 mb25" />

                            <div className="rangesliderbox">
                                <div className="rangesliderbox_title">
                                    <div>
                                        <div className="font12 fw500 color8c9">Debt Investments will grow at</div>
                                    </div>
                                    <div className="tragetvalue font13 fw700">{debtReturn}</div>
                                </div>
                                <div className="rangebox_bar mt12">
                                    <div className="form-group">


                                        <Slider step={1} min={5} max={20} onChange={e => debtPerc(e)} value={debtReturn} />

                                    </div>
                                </div>
                                <div className="flex_center justify_center mt8">
                                    <div className="font12 fw500 color9ba">5</div>
                                    <div className="font12 fw500 color9ba">20</div>
                                </div>
                                <input type="hidden" className="font14 fw500 ml15 mr15" name='debtReturn' value={debtReturn} {...register("debtReturn")} />
                            </div>


                            <div className="devider_line mt25 mb25" />

                            <div className="rangesliderbox">
                                <div className="rangesliderbox_title">
                                    <div>
                                        <div className="font12 fw500 color8c9">Gold Investments will grow at</div>
                                    </div>
                                    <div className="tragetvalue font13 fw700">{goldReturn}</div>
                                </div>
                                <div className="rangebox_bar mt12">
                                    <div className="form-group">

                                        <Slider step={1} min={5} max={20} onChange={e => goldPerc(e)} value={goldReturn} />

                                    </div>
                                </div>
                                <div className="flex_center justify_center mt8">
                                    <div className="font12 fw500 color9ba">5</div>
                                    <div className="font12 fw500 color9ba">20</div>
                                </div>
                                <input type="hidden" className="font14 fw500 ml15 mr15" name='goldReturn' value={goldReturn} {...register("goldReturn")} />
                            </div>


                            <div className="devider_line mt25 mb25" />

                            <div className="rangesliderbox">
                                <div className="rangesliderbox_title">
                                    <div>
                                        <div className="font12 fw500 color8c9">Property value will grow at</div>
                                    </div>
                                    <div className="tragetvalue font13 fw700">{propertyReturn}</div>
                                </div>
                                <div className="rangebox_bar mt12">
                                    <div className="form-group">





                                        <Slider step={1} min={5} max={20} onChange={e => propertyPerc(e)} value={propertyReturn} />


                                    </div>
                                </div>
                                <div className="flex_center justify_center mt8">
                                    <div className="font12 fw500 color9ba">5</div>
                                    <div className="font12 fw500 color9ba">20</div>
                                </div>
                                <input type="hidden" className="font14 fw500 ml15 mr15" name='propertyReturn' value={propertyReturn} {...register("propertyReturn")} />
                            </div>

                            <div className="saveBtn backsaveBtn">
                                <button type="button" className="btn btn-primary" onClick={() => Back()}>Cancel </button>
                                <button type="submit" className="btn btn-primary">Save </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Fragment>

    )
}
